<template lang="pug">
    v-tabs#employee-tabs( 
        color='grey lighten-4'  
        grow 
        :height='72'
        show-arrows
        slider-color='primary'
    )
        v-tab información general
        v-tab-item
            employee-edit()
        v-tab prevision y salud
        v-tab-item
            employee-health
        v-tab Información Extra
        v-tab-item
            employee-extra-information(:employee="employeeComp")
        v-tab APV
        v-tab-item
            employee-apv
        v-tab IPS
        v-tab-item
            employee-ips
        //v-tab cuenta de usuario
        //v-tab-item
            employee-user
        v-tab carga familiar
        v-tab-item
            employee-family
        v-tab remuneraciones
        v-tab-item
            employee-remunerations
        v-tab Contrato
        v-tab-item
            employee-contract
        v-tab descuentos por planilla
        v-tab-item
            employee-ic-quote
</template>

<script>
//
import { mapActions } from 'vuex'
//
import EmployeeEdit from './EmployeeEdit'
import EmployeeFamily from './EmployeeFamily'
import EmployeeHealth from './EmployeeHealth'
import EmployeeUser from './EmployeeUser'
import EmployeeContract from './EmployeeContract'
import EmployeeRemunerations from './EmployeeRemunerations'
import EmployeeExtraInformation from './EmployeeExtraInformation'
import EmployeeApv from './EmployeeApv'
import EmployeeIps from './EmployeeIsp'
import EmployeeIcQuote from '@/views/HumanResource/HrEmployee/HrEmployeeIcQuote'
import EmployeeService from '@/services/api/employee'

//

export default {
    data() {
        return {
            employee: {},
        }
    },
    computed: {
        employeeComp: function() {
            return this.employee
        },
    },
    beforeMount() {
        this.setTitleTopBar('Detalles del empleado')
        //this.initEmployee()
    },
    components: {
        'employee-edit': EmployeeEdit,
        'employee-family': EmployeeFamily,
        'employee-health': EmployeeHealth,
        'employee-user': EmployeeUser,
        'employee-contract': EmployeeContract,
        'employee-remunerations': EmployeeRemunerations,
        'employee-extra-information': EmployeeExtraInformation,
        'employee-apv': EmployeeApv,
        'employee-ips': EmployeeIps,
        EmployeeIcQuote,
    },
    methods: {
        /**
         *
         */

        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('EmployeeModule', {
            setEmployee: 'setEmployee',
        }),
        // async initEmployee(){
        //     this.employee = await EmployeeService.fetchById( this.$route.params.id )
        //     this.setEmployee(this.employee)
        // },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
}
</script>

<style>
    #employee-tabs .v-tabs__bar.theme--light.grey.lighten-4 .v-tabs__wrapper {
        border-bottom: 1px solid #1a237e;
    }

    #employee-tabs .v-tabs__slider {
        height: 4px;
    }
</style>
